@if (processingService.message()) {
  <div class="processing-overlay">

    <div class="processing-content">

      <div class="spinner"></div>

      <div class="processing-message">
        {{ processingService.message() }}
      </div>

    </div>

  </div>
}
